import { useCallback } from 'react';
import { AnchorId } from '../core/Enums';
import { useTour } from '../core/TourProvider';

export const useTourAnchor = (anchorKey: AnchorId) => {
  const { registerAnchor, unregisterAnchor } = useTour();

  return useCallback(
    (el: HTMLElement | null) => {
      if (el) {
        registerAnchor(anchorKey, el);
      } else {
        unregisterAnchor(anchorKey, el);
      }
    },
    [anchorKey, registerAnchor, unregisterAnchor]
  );
};
